<script>
export default {
  name: 'General',
}
</script>

<template>
  <div>
    <NuxtLayout name="default">
      <slot name="sidebar" />
    </NuxtLayout>
  </div>
</template>
